import { Radio } from '@mui/joy';
import classNames from 'classnames';
import { ComponentProps, ReactElement } from 'react';

interface S_RadioProps extends ComponentProps<typeof Radio> {
  valid?: boolean;
  invalid?: boolean;
}

export const S_Radio = ({ className, valid, invalid, ...rest }: S_RadioProps): ReactElement => (
  <Radio
    {...rest}
    className={classNames(className, { valid, invalid })}
  />
);
